import { BaseDTO } from '../global/base.dto';
import { UserListDTO } from '../user/user-list.dto';

export class CommentDTO extends BaseDTO {

    content: string;

    user: UserListDTO;

}
